import React, { useState, useCallback } from "react";
import { debounce } from "../utils/helpers";

const Searching = ({ search, isLoading }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearch = useCallback(
    debounce((term) => {
      search(term);
    }, 500),
    [search]
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      search(searchTerm);
    }
  };

  return (
    <div
      className="search-container"
      style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
      }}
    >
      <div className="form-group" style={{ marginBottom: 0 }}>
        <label
          htmlFor="search-input"
          style={{ marginRight: "10px", fontWeight: "500" }}
        >
          Cautare:
        </label>
        <input
          id="search-input"
          type="text"
          value={searchTerm}
          placeholder="Cautare clienti ..."
          className="form-control"
          style={{
            marginLeft: "10px",
            display: "inline-block",
            width: "300px",
            padding: "8px 12px",
            borderRadius: "4px",
            border: "1px solid #ddd",
          }}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
        />
        {isLoading && (
          <span
            style={{
              marginLeft: "15px",
              color: "#007bff",
              fontStyle: "italic",
            }}
          >
            Se cauta...
          </span>
        )}
      </div>
    </div>
  );
};

export default Searching;
